export enum SegmentosSubMenuEnum {
    FINANCEIRO = '1',
    SAUDE = '2',
    SEGUROS = '3',
    VAREJO = '4',
    SETOR_PUBLICO = '5',
    EDUCACAO = '6',
    MERCADO_GRAFICO = '7'
}
